import AcompanhamentoMensalContainer from "../../acompanhamento-mensal/containers/AcompanhamentoMensalContainer.vue";

const campaignRegistry = {
  "acompanhamento-mensal": {
    id: "acompanhamento-mensal",
    title: "Campanha de acompanhamento mensal",
    component: "AcompanhamentoMensalContainer",
    componentRef: AcompanhamentoMensalContainer,
    propsResolver(context = {}) {
      return {
        cdCooperado:
          context.cdCooperado ?? context.id ?? context.cdPessoa ?? null
      };
    },
    options: {}
  }
};

class CampanhaRegistryService {
  getCampaignConfig(campaignId, context = {}) {
    const campaign = campaignRegistry[campaignId];

    if (!campaign) {
      return null;
    }

    return {
      ...campaign,
      props: campaign.propsResolver ? campaign.propsResolver(context) : {}
    };
  }
}

export const campanhaRegistryService = new CampanhaRegistryService();
